module.exports = __webpack_public_path__ + "epdf-app/dashboard/indexfile/unknown-batchref-confirm-aKEN7TR8.html";